module.exports = __webpack_public_path__ + "img/26.56d5e2c7.jpg";